module.exports = __webpack_public_path__ + "static/media/clients-01.1f794aef.svg";